export default {
  filters: {
    managers: {
      placeholder: 'Verkoopmanagers',
    },
  },
  metrics: {
    collected_commission: 'Totale commissie',
  },
  fields: {
    manager: 'Manager',
    area: 'Locatie',
    total_amount: 'Verdiensten',
    companies_live: 'Live',
    restaurant: 'Restaurant',
    live_from: 'Live vanaf',
    plan_amount: 'Planbedrag',
    prepayment_bonus_amount: 'Vooruitbetalingsbonus',
    lead_source_bonus_amount: 'Leadbronbonus',
    google_business_bonus_amount: 'Google Business-koppelingsbonus',
    promo_code_bonus_amount: 'Master promotiecode-bonus',
    smart_pricing_bonus_amount: 'Slimme prijsbonus',
    mobile_app_bonus_amount: 'Mobiele app-bonus',
    sales_goal_bonus_amount: 'Verkoopsdoelbonus',
  },
  buttons: {
    export: 'Exporteren',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
  },
};
